import React, { useRef, useCallback, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import AuthNavbar from "components/Navbars/AuthNavbar.js";

import routes from "../../routes/public";

const Public = (props) => {
  const fullPagesRef = useRef("FullPages");

  const getRoutes = useCallback((routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/public") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  }, []);
  const getActiveRoute = useCallback((routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  }, []);

  const getFullPageName = useCallback(
    (routes) => {
      let pageName = getActiveRoute(routes);
      switch (pageName) {
        case "Login":
          return "login-page";
        case "Register":
          return "register-page";
        default:
          return "Default Brand Text";
      }
    },
    [getActiveRoute]
  );

  useEffect(() => {
    // Só uma vez, ao entrar no layout público — não em toda renderização.
    // Era `classList.toggle("white-content")` sem array de dependências:
    // rodava em CADA render (incluindo os disparados por setState, como o
    // clique em "Enviar arquivos" no Kit de Onboarding) e invertia o tema
    // sem motivo. `.remove()` garante o modo escuro (default dessas
    // páginas), independente de eventual `white-content` deixado pelo
    // ThemeProvider de uma sessão autenticada anterior na mesma aba.
    document.body.classList.remove("white-content");
  }, []);

  // Páginas públicas com header próprio (Tracking, Cotação Spot, Kit de
  // Onboarding, Rede Everlog) escondem o brandText do AuthNavbar — caso contrário aparece
  // "Default Brand Text Page" no canto pra rotas com :token (que não casam
  // com o getActiveRoute).
  const path = window.location.pathname || "";
  const ocultarBrandText =
    path.indexOf("/public/tracking") !== -1
    || path.indexOf("/public/cotacao-spot") !== -1
    || path.indexOf("/public/onboarding-kit") !== -1
    || path.indexOf("/public/convite-transportadora") !== -1
    || path.indexOf("/public/leilao-frete") !== -1
    || path.indexOf("/public/rede-everlog") !== -1;
  // A Rede Everlog tem cabeçalho próprio no padrão do gobid.com.br (modo claro).
  const semNavbar = path.indexOf("/public/rede-everlog") !== -1;
  const brandTextResolvido = ocultarBrandText
    ? ""
    : getActiveRoute(routes) + " Page";

  return (
    <>
      {!semNavbar && <AuthNavbar brandText={brandTextResolvido} />}
      <div className="wrapper wrapper-full-page" ref={fullPagesRef}>
        <div className={"full-page " + getFullPageName(routes)}>
          <Switch>
            {getRoutes(routes)}
            <Redirect from="*" to="/public/tracking" />
          </Switch>
          {/* <Footer fluid /> */}
        </div>
      </div>
    </>
  );
};

export default Public;
